// extracted by mini-css-extract-plugin
module.exports = {"container":"scroll_container__25d5r","chevron":"scroll_chevron__OJ5DF","move":"scroll_move__1JLwp","text":"scroll_text__303nG","pulse":"scroll_pulse__2Ihj-"};